import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { NodeUtils } from '@core/utils/node.utils';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { ProjectGroupRowDto } from '@services/dtos/rows/project-group-row.dto';
import { BudgetGroupBaseComponent } from '@shared/components/budget-group-base/budget-group-base.component';
import { CellDropZoneComponent } from '@shared/components/cell-drop-zone/cell-drop-zone.component';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, ICellRendererParams, IRowNode } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { ProjectGroupRow } from '../../rows/groups/project-group.row';

@Component({
  selector: 'al-project-group-cell-renderer',
  templateUrl: 'project-group-cell-renderer.component.html',
  styleUrl: 'project-group-cell-renderer.component.scss',
  imports: [BudgetGroupBaseComponent, CellDropZoneComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectGroupCellRendererComponent implements ICellRendererAngularComp {
  public readonly translationKey = 'common.project';
  public readonly faBriefCase = faBriefcase;

  public project?: ProjectGroupRowDto;
  public node!: IRowNode<ProjectGroupRow>;
  public refreshSubject = new Subject<void>();
  public api?: GridApi;

  public get isDroppable() {
    return NodeUtils.isCellDroppable(this.node);
  }

  public constructor(private change: ChangeDetectorRef) {}

  public agInit(params: ICellRendererParams<ProjectGroupRow>) {
    this.node = params.node;
    this.api = params.api;
    this.project = params.data?.dto;
  }

  public refresh(_: ICellRendererParams<ProjectGroupRow>) {
    this.refreshSubject.next();
    this.change.markForCheck();
    return true;
  }

  public expand(expand = true) {
    this.node.setExpanded(expand);
  }
}
